import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export const useLoginUser = () => {
  const loginUser = useSelector<RootState>((state) => state.auth.user) as any;
  return { loginUser };
};
